// ─────────────────────────────────────────────────────────────────────────────
// Stepper.js — the 3-step progress indicator. `current` is the 1-based active
// step; earlier steps render a check, later steps render their number.
// ─────────────────────────────────────────────────────────────────────────────
import { Fragment } from "react";
import styles from "./InviteModal.module.css";
import { STEPS } from "./inviteData";
import { CheckIcon } from "./icons";

export default function Stepper({ current }) {
  return (
    <div className={styles.stepper}>
      {STEPS.map((step, i) => {
        const done = step.id < current;
        const active = step.id === current;
        const dotClass = done ? styles.stepDone : active ? styles.stepActive : styles.stepTodo;

        return (
          <Fragment key={step.id}>
            <div className={styles.step}>
              <span className={`${styles.stepDot} ${dotClass}`}>
                {done ? <CheckIcon size={14} /> : step.id}
              </span>
              <span className={`${styles.stepLabel} ${done || active ? styles.stepLabelOn : ""}`}>
                {step.label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <span className={`${styles.stepLine} ${done ? styles.stepLineOn : ""}`} />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}
